import React from "react";
import { Button } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ManuallyConfirmationStatusType } from "../../../enums/index";
import {
  GetLineStateText,
  GetLineStateClass,
  GetLineServiceText,
  GetInitialPackageText,
  SeparateCountryCodeFromNumber,
  getManuallyConfirmationStatusClass,
  getManuallyConfirmationStatusText,
  ToPersianNumber,
  DateToPersianNumber,
} from "../../../functions/index";
import Constants from "../../../constants/constants";
import { formsButtonType } from "../../../enums/index";
import FormTexts from "../../../constants/forms";
function LinesTables(props) {
  return (
    <Table responsive className="roundedCorners">
      <thead>
        <tr>
          {props.heading.map((h, index) => (
            <th key={index}>{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.data &&
          props.data.map((d, index) => (
            <tr key={index}>
              <td className="ltr">
                {ToPersianNumber(SeparateCountryCodeFromNumber(d.LineNumber))}
              </td>
              <td className={d.IsEnabled ? "enabled" : "disabled"}>
                {d.IsEnabled ? Constants.On : Constants.Off}
              </td>
              <td>
                {GetInitialPackageText(d.initialPackage)}
                {d.IsFree &&
                  Constants.AuthHistoryArray.open +
                    Constants.Free +
                    Constants.AuthHistoryArray.close}
              </td>
              <td>{GetLineServiceText(d.LineServiceType)}</td>
              <td className={GetLineStateClass(d.Status)}>
                {GetLineStateText(d.Status)}
              </td>
              <td>{DateToPersianNumber(d.PersianActivationDate)}</td>
              <td>{DateToPersianNumber(d.PersianExpirationDate)}</td>

              {!d.spinner ? (
                d.ManuallyConfirmationStatus ===
                ManuallyConfirmationStatusType.ReadyToAccept() ? (
                  <td
                    className={getManuallyConfirmationStatusClass(
                      d.ManuallyConfirmationStatus
                    )}
                  >
                    {d.RejectActivationReason ? (
                      <span className="direction-rtl">
                        {Constants.RejectActivatedText} &nbsp;
                        <b className="direction-rtl">
                          {d.ConfirmationUsername}
                        </b>{" "}
                        &nbsp;
                        {Constants.Because}
                        <br></br>
                        {d.RejectActivationReason}
                        <br></br>
                        {d.PersianConfirmationDate &&
                          DateToPersianNumber(d.PersianConfirmationDate)}
                      </span>
                    ) : (
                      <Button
                        className="submit-button big lines-button reject"
                        variant="primary"
                        onClick={(e) => props.rejectLineModal(e, d.Id)}
                      >
                        {FormTexts.Buttons(formsButtonType.RejectActivation())}
                      </Button>
                    )}

                    <Button
                      className="submit-button big lines-button"
                      variant="primary"
                      onClick={(e) => props.activateLineModal(e, d.Id)}
                    >
                      {getManuallyConfirmationStatusText(
                        d.ManuallyConfirmationStatus
                      )}
                    </Button>
                  </td>
                ) : d.ManuallyConfirmationStatus ===
                  ManuallyConfirmationStatusType.NoNeed() ? (
                  <td>
                    <span>
                      {" "}
                      {getManuallyConfirmationStatusText(
                        d.ManuallyConfirmationStatus
                      )}
                    </span>
                  </td>
                ) : d.ConfirmationUsername ? (
                  <td>
                    <span className="direction-rtl">
                      {Constants.ActivatedBy} &nbsp;
                      <b className="direction-rtl">
                        {d.ConfirmationUsername}
                      </b>{" "}
                      &nbsp;
                      {d.PersianConfirmationDate &&
                        DateToPersianNumber(d.PersianConfirmationDate)}
                    </span>
                  </td>
                ) : (
                  <td>
                    <span>
                      {" "}
                      {getManuallyConfirmationStatusText(
                        d.ManuallyConfirmationStatus
                      )}
                    </span>
                  </td>
                )
              ) : (
                <td
                  className={getManuallyConfirmationStatusClass(
                    d.ManuallyConfirmationStatus
                  )}
                >
                  <Button
                    className="submit-button big lines-button"
                    variant="primary"
                  >
                    <FontAwesomeIcon icon={faSpinner} spin />
                  </Button>
                </td>
              )}
            </tr>
          ))}
      </tbody>
    </Table>
  );
}
export default LinesTables;
